var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.showExportDefaults,
            callback: function($$v) {
              _vm.showExportDefaults = $$v
            },
            expression: "showExportDefaults"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-stepper",
                {
                  model: {
                    value: _vm.exportDefaultsStep,
                    callback: function($$v) {
                      _vm.exportDefaultsStep = $$v
                    },
                    expression: "exportDefaultsStep"
                  }
                },
                [
                  _c(
                    "v-stepper-header",
                    [
                      _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            step: "1",
                            completed: _vm.exportDefaultsStep > 1
                          }
                        },
                        [_vm._v("Invoice Defaults")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-stepper-step",
                        {
                          attrs: {
                            step: "2",
                            completed: _vm.exportDefaultsStep > 2
                          }
                        },
                        [_vm._v("Expense Defaults")]
                      ),
                      _vm._v(" "),
                      _vm.configuredToCollectTax
                        ? _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                step: "3",
                                completed: _vm.exportDefaultsStep > 3
                              }
                            },
                            [_vm._v("Tax")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-items",
                    [
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "1" } },
                        [
                          _c("h3", [_vm._v("Direct Invoicing")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "font-weight-light" }, [
                            _vm._v(
                              "\n                  When you cut an invoice directly to a customer or dispatcher\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Invoice Sales Item")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "\n                      transportation sales line item for newly created invoices\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                { staticClass: "pl-3 pt-1" },
                                [
                                  _vm.editExportDefaults
                                    ? _c("v-autocomplete", {
                                        staticClass: "mt-2",
                                        attrs: {
                                          items: _vm.salesItems,
                                          loading: _vm.loadingSalesItems,
                                          disabled: _vm.loadingSalesItems,
                                          label: "Quickbooks Sales Item",
                                          "item-text": "description",
                                          "item-value": "itemId",
                                          "return-object": ""
                                        },
                                        model: {
                                          value:
                                            _vm.editExportDefaults.invoices
                                              .salesItem,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editExportDefaults.invoices,
                                              "salesItem",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "editExportDefaults.invoices.salesItem"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-avatar",
                                    { staticClass: "pl-3" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            fab: "",
                                            small: "",
                                            flat: "",
                                            color: "accent",
                                            disabled: _vm.loadingSalesItems
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { color: "accent" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.refreshQuickbooksSalesItems(
                                                    _vm.company.id
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("refresh")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            "\n                      Customer Payment Terms\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "\n                      payment terms from customers for newly created invoices\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                { staticClass: "pl-3" },
                                [
                                  _vm.editExportDefaults
                                    ? _c("v-select", {
                                        attrs: {
                                          loading: _vm.loadingSalesTerms,
                                          disabled: _vm.loadingSalesTerms,
                                          items: _vm.salesTerms,
                                          label: "Payment Terms",
                                          "item-text": "name",
                                          "item-value": "id",
                                          "return-object": ""
                                        },
                                        model: {
                                          value:
                                            _vm.editExportDefaults.invoices
                                              .paymentTerms,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editExportDefaults.invoices,
                                              "paymentTerms",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "editExportDefaults.invoices.paymentTerms"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-avatar",
                                    { staticClass: "pl-3" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            fab: "",
                                            small: "",
                                            flat: "",
                                            color: "accent",
                                            disabled: _vm.loadingSalesTerms
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { color: "accent" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.refreshQuickbooksPaymentTerms(
                                                    _vm.company.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        refresh\n                      "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                large: "",
                                loading: _vm.loadingBtn,
                                color: "accent"
                              },
                              on: {
                                click: function($event) {
                                  _vm.exportDefaultsStep = 2
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "pr-2",
                                  attrs: { large: "", color: "white" }
                                },
                                [
                                  [
                                    _vm._v(
                                      "\n                    credit_card\n                  "
                                    )
                                  ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("terms.billable-expense")) +
                                    " Defaults"
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                flat: "",
                                loading: _vm.loadingBtn,
                                color: "accent"
                              },
                              on: {
                                click: function($event) {
                                  _vm.showExportDefaults = false
                                }
                              }
                            },
                            [
                              _c("v-icon", { staticClass: "pr-2" }, [
                                _vm._v("cancel")
                              ]),
                              _vm._v("\n                Cancel\n              ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "2" } },
                        [
                          _c("h3", [
                            _vm._v(_vm._s(_vm.$t("terms.billable-expense")))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "font-weight-light" }, [
                            _vm._v(
                              "\n                  When a " +
                                _vm._s(_vm.$t("terms.vendor")) +
                                " handles your customer's load\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Expense Account")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "\n                      account based expense line for newly created bills\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                { staticClass: "pl-3 pt-1 pb-3" },
                                [
                                  _vm.editExportDefaults
                                    ? _c("v-autocomplete", {
                                        staticClass: "mt-2",
                                        attrs: {
                                          items: _vm.quickbooksExpenseAccounts,
                                          loading: _vm.loadingAccounts,
                                          disabled: _vm.loadingAccounts,
                                          label: "Quickbooks Expense Account",
                                          "item-text": "accountName",
                                          "item-value": "accountId",
                                          "return-object": ""
                                        },
                                        model: {
                                          value:
                                            _vm.editExportDefaults.bills
                                              .expenseAccount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editExportDefaults.bills,
                                              "expenseAccount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "editExportDefaults.bills.expenseAccount"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-avatar",
                                    { staticClass: "pl-3" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            fab: "",
                                            small: "",
                                            flat: "",
                                            color: "accent",
                                            disabled: _vm.loadingAccounts
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { color: "accent" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.refreshQuickbooksAccounts(
                                                    _vm.company.id
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("refresh")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        {
                                          staticClass:
                                            "font-weight-bold tall-title"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.$t("terms.vendor")) +
                                              " Payment Terms\n                      "
                                          ),
                                          _c("help-popover", [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "ma-0 font-weight-light"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          Vendor discounts are applied unique to the vendor. For new vendors, " +
                                                    _vm._s(
                                                      _vm.$t("site-title.brief")
                                                    ) +
                                                    " will\n                          suggest the following terms and accounts.\n                        "
                                                )
                                              ]
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "\n                      payment terms to vendors for newly created bills\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                { staticClass: "pl-3" },
                                [
                                  _vm.editExportDefaults
                                    ? _c("v-select", {
                                        attrs: {
                                          items: _vm.salesTerms,
                                          loading: _vm.loadingSalesTerms,
                                          disabled: _vm.loadingSalesTerms,
                                          label: "Payment Terms",
                                          "item-text": "name",
                                          "item-value": "id",
                                          "return-object": ""
                                        },
                                        model: {
                                          value:
                                            _vm.editExportDefaults.bills
                                              .paymentTerms,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editExportDefaults.bills,
                                              "paymentTerms",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "editExportDefaults.bills.paymentTerms"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-avatar",
                                    { staticClass: "pl-3" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            fab: "",
                                            small: "",
                                            flat: "",
                                            color: "accent",
                                            disabled: _vm.loadingSalesTerms
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { color: "accent" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.refreshQuickbooksPaymentTerms(
                                                    _vm.company.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        refresh\n                      "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-list-tile-title",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Dispatch Income")]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      "\n                    account based dispatch fee collected for newly created bills\n                  "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { staticClass: "pl-3 pt-1 pb-3" },
                            [
                              _vm.editExportDefaults
                                ? _c("v-autocomplete", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      items: _vm.quickbooksIncomeAccounts,
                                      loading: _vm.loadingAccounts,
                                      disabled: _vm.loadingAccounts,
                                      label: "Quickbooks Dispatch Fee Account",
                                      "item-text": "accountName",
                                      "item-value": "accountId",
                                      "return-object": ""
                                    },
                                    model: {
                                      value:
                                        _vm.editExportDefaults.bills
                                          .dispatchFeeAccount,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editExportDefaults.bills,
                                          "dispatchFeeAccount",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editExportDefaults.bills.dispatchFeeAccount"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-avatar",
                                {
                                  staticClass: "pl-3",
                                  attrs: { disabled: _vm.loadingAccounts }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        small: "",
                                        flat: "",
                                        color: "accent",
                                        disabled: _vm.loadingAccounts
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { color: "accent" },
                                          on: {
                                            click: function($event) {
                                              return _vm.refreshQuickbooksAccounts(
                                                _vm.company.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("refresh")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-list-tile-title",
                                    {
                                      staticClass: "font-weight-bold tall-title"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Trailer Lease Income\n                    "
                                      ),
                                      _c("help-popover", [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "ma-0 font-weight-light"
                                          },
                                          [
                                            _vm._v(
                                              "\n                        Trailer lease fees are only suggested for drivers who are part of your company's\n                        preferred team of drivers.  You can of course apply any income discount to any vendor.\n                      "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      "\n                    account based trailer lease fee collected for newly created bills\n                  "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { staticClass: "pl-3 pt-1 pb-3" },
                            [
                              _vm.editExportDefaults
                                ? _c("v-autocomplete", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      items: _vm.quickbooksIncomeAccounts,
                                      loading: _vm.loadingAccounts,
                                      disabled: _vm.loadingAccounts,
                                      label:
                                        "Quickbooks Trailer Lease Fee Account",
                                      "item-text": "accountName",
                                      "item-value": "accountId",
                                      "return-object": ""
                                    },
                                    model: {
                                      value:
                                        _vm.editExportDefaults.bills
                                          .trailerLeaseFeeAccount,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editExportDefaults.bills,
                                          "trailerLeaseFeeAccount",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editExportDefaults.bills.trailerLeaseFeeAccount"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-avatar",
                                { staticClass: "pl-3" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        fab: "",
                                        small: "",
                                        flat: "",
                                        color: "accent",
                                        disabled: _vm.loadingAccounts
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { color: "accent" },
                                          on: {
                                            click: function($event) {
                                              return _vm.refreshQuickbooksAccounts(
                                                _vm.company.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("refresh")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                large: "",
                                loading: _vm.loadingBtn,
                                color: "accent"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.completeStep2()
                                }
                              }
                            },
                            [
                              _vm.configuredToCollectTax
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "pr-2",
                                      attrs: { large: "", color: "white" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  account_balance\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.configuredToCollectTax
                                ? _c("span", [_vm._v("Tax Liability")])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.configuredToCollectTax
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "pr-2",
                                      attrs: { large: "", color: "white" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  save\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.configuredToCollectTax
                                ? _c("span", [
                                    _vm._v("Save Quickbooks Export Defaults")
                                  ])
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                loading: _vm.loadingBtn,
                                color: "accent"
                              },
                              on: {
                                click: function($event) {
                                  _vm.exportDefaultsStep = 1
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "pr-2",
                                  attrs: { large: "", color: "white" }
                                },
                                [
                                  _vm._v(
                                    "\n                  receipt\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Invoicing Defaults")])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                flat: "",
                                loading: _vm.loadingBtn,
                                color: "accent"
                              },
                              on: {
                                click: function($event) {
                                  _vm.showExportDefaults = false
                                }
                              }
                            },
                            [
                              _c("v-icon", { staticClass: "pr-2" }, [
                                _vm._v("cancel")
                              ]),
                              _vm._v("\n                Cancel\n              ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.configuredToCollectTax
                        ? _c(
                            "v-stepper-content",
                            { attrs: { step: "3" } },
                            [
                              _c("h3", [_vm._v("Tax Liability")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(
                                  "\n                  When you collect or pay transaction taxes, add these Tax Codes to line items\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                { attrs: { "two-line": "" } },
                                [
                                  _c(
                                    "v-list-tile",
                                    [
                                      _vm.editExportDefaults
                                        ? _c("v-autocomplete", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass: "mt-2",
                                            attrs: {
                                              items: _vm.quickbooksSalesTaxCodes(
                                                _vm.company.id
                                              ),
                                              loading: _vm.loadingTaxCodes,
                                              disabled:
                                                !_vm.configuredToCollectTax ||
                                                _vm.loadingTaxCodes,
                                              label:
                                                "Quickbooks Sales Tax Code",
                                              "item-text": "name",
                                              "item-value": "id",
                                              "return-object": true,
                                              "error-messages": _vm.errors.first(
                                                "salesTaxCode",
                                                "qbTaxCode"
                                              ),
                                              "data-vv-as":
                                                "Quickbooks Sales Tax Code",
                                              "data-vv-name": "salesTaxCode",
                                              "data-vv-scope": "qbTaxCode"
                                            },
                                            model: {
                                              value:
                                                _vm.editExportDefaults.invoices
                                                  .taxCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editExportDefaults
                                                    .invoices,
                                                  "taxCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editExportDefaults.invoices.taxCode"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-avatar",
                                        { staticClass: "pl-3" },
                                        [
                                          _vm.editExportDefaults
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    fab: "",
                                                    small: "",
                                                    flat: "",
                                                    color: "accent",
                                                    disabled:
                                                      !_vm.configuredToCollectTax ||
                                                      _vm.loadingTaxCodes
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "accent"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.refreshQuickbooksTaxCodes(
                                                            _vm.company.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("refresh")]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile",
                                    [
                                      _vm.editExportDefaults
                                        ? _c("v-autocomplete", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            staticClass: "mt-2",
                                            attrs: {
                                              items: _vm.quickbooksPurchaseTaxCodes(
                                                _vm.company.id
                                              ),
                                              loading: _vm.loadingTaxCodes,
                                              disabled:
                                                !_vm.configuredToCollectTax ||
                                                _vm.loadingTaxCodes,
                                              label:
                                                "Quickbooks Purchase Tax Code",
                                              "item-text": "name",
                                              "item-value": "id",
                                              "return-object": true,
                                              "error-messages": _vm.errors.first(
                                                "purchaseTaxCode",
                                                "qbTaxCode"
                                              ),
                                              "data-vv-as":
                                                "Quickbooks Purchase Tax Code",
                                              "data-vv-name": "purchaseTaxCode",
                                              "data-vv-scope": "qbTaxCode"
                                            },
                                            model: {
                                              value:
                                                _vm.editExportDefaults.bills
                                                  .taxCode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editExportDefaults.bills,
                                                  "taxCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editExportDefaults.bills.taxCode"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-avatar",
                                        { staticClass: "pl-3" },
                                        [
                                          _vm.editExportDefaults
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    fab: "",
                                                    small: "",
                                                    flat: "",
                                                    color: "accent",
                                                    disabled:
                                                      !_vm.configuredToCollectTax ||
                                                      _vm.loadingTaxCodes
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "accent"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.refreshQuickbooksTaxCodes(
                                                            _vm.company.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("refresh")]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    block: "",
                                    large: "",
                                    loading: _vm.loadingBtn,
                                    color: "accent"
                                  },
                                  on: { click: _vm.saveExportDefaults }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "pr-2",
                                      attrs: { large: "", color: "white" }
                                    },
                                    [
                                      [
                                        _vm._v(
                                          "\n                    save\n                  "
                                        )
                                      ]
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v("Save Quickbooks Export Defaults")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    block: "",
                                    loading: _vm.loadingBtn,
                                    color: "accent"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.exportDefaultsStep = 2
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "pr-2",
                                      attrs: { large: "", color: "white" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  credit_card\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("terms.billable-expense")) +
                                        " Defaults"
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    block: "",
                                    flat: "",
                                    loading: _vm.loadingBtn,
                                    color: "accent"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.showExportDefaults = false
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { staticClass: "pr-2" }, [
                                    _vm._v("cancel")
                                  ]),
                                  _vm._v(
                                    "\n                Cancel\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.vendorDispatcher
        ? _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "500" },
              model: {
                value: _vm.showUpdateVendorDispatcher,
                callback: function($$v) {
                  _vm.showUpdateVendorDispatcher = $$v
                },
                expression: "showUpdateVendorDispatcher"
              }
            },
            [
              _c(
                "v-card",
                { class: { "pa-4": !_vm.$vuetify.breakpoint.smAndDown } },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { extended: "", dense: "" } },
                        [
                          _c("v-icon", { attrs: { color: "accent" } }, [
                            _vm._v("headset_mic")
                          ]),
                          _vm._v(" "),
                          _c("v-toolbar-title", [
                            _vm._v(_vm._s(_vm.vendorDispatcher.companyName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { slot: "extension" }, slot: "extension" },
                            [
                              _c(
                                "v-list-tile",
                                { staticClass: "pl-2" },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      false
                                        ? _c("v-list-tile-title", [
                                            _vm._v("A little more prominent")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-sub-title",
                                        { staticClass: "font-italic" },
                                        [_vm._v("Dispatcher Contact Info")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer", { staticClass: "mb-3" }),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { attrs: { "pa-0": "", flat: "" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Name" },
                            model: {
                              value: _vm.vendorDispatcher.name,
                              callback: function($$v) {
                                _vm.$set(_vm.vendorDispatcher, "name", $$v)
                              },
                              expression: "vendorDispatcher.name"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "Email" },
                            model: {
                              value: _vm.vendorDispatcher.email,
                              callback: function($$v) {
                                _vm.$set(_vm.vendorDispatcher, "email", $$v)
                              },
                              expression: "vendorDispatcher.email"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "Phone (for SMS Texts)" },
                            model: {
                              value: _vm.vendorDispatcher.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.vendorDispatcher, "phone", $$v)
                              },
                              expression: "vendorDispatcher.phone"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        { staticClass: "align-right" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                loading: _vm.loadingBtn,
                                flat: "",
                                large: "",
                                outline: ""
                              },
                              on: {
                                click: _vm.closeUpdateVendorDispatcherDialog
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "pr-2", attrs: { large: "" } },
                                [_vm._v("cancel")]
                              ),
                              _vm._v("\n              Cancel\n            ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                loading: _vm.loadingBtn,
                                large: ""
                              },
                              on: { click: _vm.saveVendorDispatcher }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "pr-2", attrs: { large: "" } },
                                [_vm._v("save")]
                              ),
                              _vm._v("\n              Save\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "pa-0 ma-0", attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            { staticClass: "pa-0", attrs: { column: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "full-card-desktop py-0 px-0",
                      attrs: { expand: "", flat: "" }
                    },
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "qb_tabs",
                          attrs: { "hide-slider": "" }
                        },
                        [
                          _c(
                            "v-tabs-items",
                            {
                              model: {
                                value: _vm.activeTab,
                                callback: function($$v) {
                                  _vm.activeTab = $$v
                                },
                                expression: "activeTab"
                              }
                            },
                            [
                              _c(
                                "v-tab-item",
                                { attrs: { value: "connect", lazy: "" } },
                                [
                                  _c(
                                    "v-toolbar",
                                    {
                                      staticClass: "darken-1",
                                      attrs: { flat: "", color: "white" }
                                    },
                                    [
                                      !_vm.hasCurrentCredential
                                        ? _c(
                                            "v-icon",
                                            { attrs: { color: "red" } },
                                            [
                                              _vm._v(
                                                "\n                        report\n                      "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "v-icon",
                                            { attrs: { color: "green" } },
                                            [_vm._v("offline_bolt")]
                                          ),
                                      _vm._v(" "),
                                      _c("v-toolbar-title", [
                                        _vm._v("Quickbooks Connect")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-toolbar-items",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                flat: "",
                                                color: "accent"
                                              },
                                              on: {
                                                click:
                                                  _vm.refreshQuickbooksAccountInfo
                                              }
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  staticClass: "align-center",
                                                  attrs: { column: "" }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("download")
                                                  ]),
                                                  _vm._v(
                                                    "\n                            Refresh\n                          "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.hasCurrentCredential ||
                                  _vm.daysUntilQuickbooksCredentialsExpire(
                                    _vm.company
                                  ) < 8
                                    ? [
                                        _c(
                                          "v-alert",
                                          {
                                            attrs: {
                                              value: !_vm.hasCurrentCredential,
                                              type: "error"
                                            }
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v("Requires Authentication")
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-alert",
                                          {
                                            attrs: {
                                              type: "warning",
                                              value:
                                                _vm.hasCurrentCredential &&
                                                _vm.daysUntilQuickbooksCredentialsExpire(
                                                  _vm.company
                                                ) < 8
                                            }
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                "Credentials expire in " +
                                                  _vm._s(
                                                    _vm.daysUntilQuickbooksCredentialsExpire(
                                                      _vm.company
                                                    )
                                                  ) +
                                                  " days"
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "pa-2" }, [
                                          _c("p", [
                                            _vm._v(
                                              "For your security, Quickbooks requires that you provide Quickbooks credentials at\n                          least every 100 days."
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "Click below to continue allowing " +
                                                _vm._s(
                                                  _vm.$t("site-title.brief")
                                                ) +
                                                " to communicate with your\n                          Quickbooks account."
                                            )
                                          ])
                                        ])
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { "two-lines": "" } },
                                    [
                                      _c(
                                        "v-subheader",
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "pr-2" },
                                            [_vm._v("settings")]
                                          ),
                                          _vm._v(
                                            "\n                        Quickbooks Company Profile\n                      "
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                            business\n                          "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.quickbooksCompanyName(
                                                      _vm.company
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.quickbooksCompanyLegalName(
                                                      _vm.company
                                                    )
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                            repeat\n                          "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.quickbooksSubscriptionSkuName(
                                                      _vm.company
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              !_vm.subscriptionSupportsBilling
                                                ? _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.quickbooksSubscriptionRequiredForBilling
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !_vm.subscriptionSupportsBilling
                                            ? _c(
                                                "v-list-tile-avatar",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        fab: "",
                                                        flat: "",
                                                        small: "",
                                                        color: "red"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        { staticClass: "pr-2" },
                                                        [_vm._v("report")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.configuredToCollectTax
                                        ? _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            account_balance\n                          "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "Default Tax Codes Applied"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      "to invoice and bill transactions. Can be modified per load if necessary."
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        disabled: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            account_balance\n                          "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "Tax Codes do not Apply"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      "Your Quickbooks Account is not set up to remit transaction tax. To change this, Go to GST and select Get started."
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "v-subheader",
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "pr-2" },
                                            [_vm._v("fingerprint")]
                                          ),
                                          _vm._v(
                                            "\n                        Authorization\n                      "
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                            person_outline\n                          "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.quickbooksCompanyAuthenticatedBy(
                                                        _vm.company
                                                      )
                                                    ) +
                                                    "\n                          "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "font-italic"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatDate")(
                                                          _vm.quickbooksCompanyAuthenticated(
                                                            _vm.company
                                                          )
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [_vm._v("event")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatDay")(
                                                      _vm.quickbooksCompanyCredentialExpires(
                                                        _vm.company
                                                      )
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "font-italic"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Must re-authorize " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "site-title.brief"
                                                          )
                                                        ) +
                                                        " on or before"
                                                    )
                                                  ]
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.hasOfficePermission
                                        ? _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      }
                                                    },
                                                    [_vm._v("autorenew")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                            Authorize " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "site-title.brief"
                                                          )
                                                        ) +
                                                        "\n                          "
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c("v-quickbooks-connect-btn", {
                                                attrs: {
                                                  "company-id": _vm.company.id,
                                                  loading: _vm.qbButtonLoading
                                                },
                                                on: {
                                                  connecting:
                                                    _vm.connectAccount,
                                                  connected:
                                                    _vm.connectCompleted
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasOfficePermission && _vm.isConnected
                                        ? _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { color: "red" } },
                                                    [_vm._v("clear")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                            Revoke Permission\n                          "
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "pl-0 pr-0 mr-2",
                                                  attrs: {
                                                    flat: "",
                                                    color: "red"
                                                  },
                                                  on: {
                                                    click: _vm.disconnectAccount
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { staticClass: "pr-2" },
                                                    [_vm._v("cancel")]
                                                  ),
                                                  _vm._v(
                                                    "\n                          Revoke\n                        "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tab-item",
                                { attrs: { value: "defaults", lazy: "" } },
                                [
                                  _c(
                                    "v-toolbar",
                                    {
                                      staticClass: "darken-1",
                                      attrs: { flat: "", color: "white" }
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "align-center cursor-pointer",
                                        attrs: {
                                          height: "38",
                                          width: "38",
                                          src: "/static/Quickbooks-Logo.png"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-toolbar-title", [
                                        _vm._v("Quickbooks Export Defaults")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-toolbar-items",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                flat: "",
                                                color: "accent"
                                              },
                                              on: {
                                                click:
                                                  _vm.showExportDefaultsDialog
                                              }
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  staticClass: "align-center",
                                                  attrs: { column: "" }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("edit")
                                                  ]),
                                                  _vm._v(
                                                    "\n                            Edit\n                        "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                flat: "",
                                                color: "accent"
                                              },
                                              on: {
                                                click:
                                                  _vm.reloadCompanyQuickbooksData
                                              }
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  staticClass: "align-center",
                                                  attrs: { column: "" }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("refresh")
                                                  ]),
                                                  _vm._v(
                                                    "\n                            Reload\n                        "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { "three-lines": "" } },
                                    [
                                      _c(
                                        "v-subheader",
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "pr-2" },
                                            [_vm._v("receipt")]
                                          ),
                                          _vm._v(
                                            "\n                      Direct Invoicing\n                    "
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v("Invoice Sales Item")
                                              ]),
                                              _vm._v(" "),
                                              _vm.taxCodesStatus[_vm.company.id]
                                                ? _c("v-list-tile-sub-title", [
                                                    _vm._v("loading ...")
                                                  ])
                                                : _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .defaultInvoiceSalesItem
                                                          .description
                                                      )
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v("Customer Payment Terms")
                                              ]),
                                              _vm._v(" "),
                                              _vm.taxCodesStatus[_vm.company.id]
                                                ? _c("v-list-tile-sub-title", [
                                                    _vm._v("loading ...")
                                                  ])
                                                : _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .defaultCustomerInvoiceTerms
                                                          .name
                                                      )
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-subheader",
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "pr-2" },
                                            [_vm._v("credit_card")]
                                          ),
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t("terms.billable-expense")
                                              ) +
                                              "\n                    "
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "Transportation Fee Expense Account"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.taxCodesStatus[_vm.company.id]
                                                ? _c("v-list-tile-sub-title", [
                                                    _vm._v("loading ...")
                                                  ])
                                                : _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .defaultTransportationFeeExpenseAccount
                                                          .accountName
                                                      )
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("terms.vendor")
                                                  ) + " Payment Terms"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.taxCodesStatus[_vm.company.id]
                                                ? _c("v-list-tile-sub-title", [
                                                    _vm._v("loading ...")
                                                  ])
                                                : _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .defaultVendorBillTerms
                                                          .name
                                                      )
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "Dispatch Fee Income Account"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.taxCodesStatus[_vm.company.id]
                                                ? _c("v-list-tile-sub-title", [
                                                    _vm._v("loading ...")
                                                  ])
                                                : _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm
                                                            .defaultDispatchFeeIncomeAccount
                                                            .accountName
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "Trailer Lease Fee Account"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.taxCodesStatus[_vm.company.id]
                                                ? _c("v-list-tile-sub-title", [
                                                    _vm._v("loading ...")
                                                  ])
                                                : _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          _vm
                                                            .defaultTrailerLeaseFeeIncomeAccount
                                                            .accountName
                                                        ) +
                                                        "\n                        "
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.configuredToCollectTax
                                        ? _c(
                                            "v-subheader",
                                            [
                                              _c(
                                                "v-icon",
                                                { staticClass: "pr-2" },
                                                [_vm._v("account_balance")]
                                              ),
                                              _vm._v(
                                                "\n                      Tax Liability\n                    "
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.configuredToCollectTax
                                        ? _c(
                                            "v-list-tile",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v("Sales Tax Code")
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.defaultTaxCodes.sales.id
                                                    ? _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .defaultTaxCodes
                                                                .sales.name
                                                            ) +
                                                              " (" +
                                                              _vm._s(
                                                                _vm
                                                                  .defaultTaxCodes
                                                                  .sales
                                                                  .description
                                                              ) +
                                                              ")"
                                                          )
                                                        ]
                                                      )
                                                    : _vm.taxCodesStatus[
                                                        _vm.company.id
                                                      ]
                                                    ? _c(
                                                        "v-list-tile-sub-title",
                                                        [_vm._v("loading ...")]
                                                      )
                                                    : _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _vm._v(
                                                            "None Selected."
                                                          )
                                                        ]
                                                      )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.configuredToCollectTax
                                        ? _c(
                                            "v-list-tile",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v("Purchase Tax Code")
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.defaultTaxCodes.purchase
                                                    .id
                                                    ? _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .defaultTaxCodes
                                                                .purchase.name
                                                            ) +
                                                              " (" +
                                                              _vm._s(
                                                                _vm
                                                                  .defaultTaxCodes
                                                                  .purchase
                                                                  .description
                                                              ) +
                                                              ")"
                                                          )
                                                        ]
                                                      )
                                                    : _vm.taxCodesStatus[
                                                        _vm.company.id
                                                      ]
                                                    ? _c(
                                                        "v-list-tile-sub-title",
                                                        [_vm._v("loading ...")]
                                                      )
                                                    : _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _vm._v(
                                                            "None Selected."
                                                          )
                                                        ]
                                                      )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isConnected
                                ? _c(
                                    "v-tab-item",
                                    { attrs: { value: "customers", lazy: "" } },
                                    [
                                      _c(
                                        "v-toolbar",
                                        {
                                          staticClass: "darken-1",
                                          attrs: { flat: "", color: "white" }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "green" } },
                                            [_vm._v("face")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-toolbar-title",
                                            [
                                              _vm._v(
                                                "\n                      Quickbooks Customers using " +
                                                  _vm._s(
                                                    _vm.$t("site-title.brief")
                                                  ) +
                                                  "\n\n                      "
                                              ),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-3",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.refreshCustomers()
                                                    }
                                                  }
                                                },
                                                [_vm._v("refresh")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            staticClass: "mx-3",
                                            attrs: {
                                              flat: "",
                                              label: "Search",
                                              "append-icon": "close",
                                              "prepend-inner-icon": "search"
                                            },
                                            on: {
                                              "click:append": function($event) {
                                                _vm.customerSearch = null
                                              }
                                            },
                                            model: {
                                              value: _vm.customerSearch,
                                              callback: function($$v) {
                                                _vm.customerSearch = $$v
                                              },
                                              expression: "customerSearch"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        [
                                          _c("v-subheader", [
                                            _vm._v(
                                              "Customers with " +
                                                _vm._s(
                                                  _vm.$t("site-title.brief")
                                                ) +
                                                " Accounts"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.loadingCustomers
                                            ? _c(
                                                "v-list-tile",
                                                [
                                                  _c("v-progress-circular", {
                                                    attrs: {
                                                      indeterminate: "",
                                                      color: "primary"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(_vm.knownCustomers, function(
                                            customer,
                                            i
                                          ) {
                                            return !_vm.loadingCustomers
                                              ? [
                                                  _c(
                                                    "v-list-tile",
                                                    {
                                                      key:
                                                        "customer-no-discounts" +
                                                        i
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-tile-action",
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                flat: "",
                                                                fab: "",
                                                                small: "",
                                                                color: "accent"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeCustomerMapping(
                                                                    customer
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v("cancel")
                                                              ])
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-content",
                                                        [
                                                          _c(
                                                            "v-list-tile-title",
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  customer.ltnCompanyName
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-tile-sub-title",
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    customer.qbDisplayName
                                                                  ) +
                                                                  " (" +
                                                                  _vm._s(
                                                                    customer.qbCompanyId
                                                                  ) +
                                                                  ")\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              : _vm._e()
                                          }),
                                          _vm._v(" "),
                                          _c("v-subheader", [
                                            _vm._v("Other Quickbooks Customers")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-group",
                                            [
                                              _c(
                                                "v-list-tile",
                                                {
                                                  attrs: { slot: "activator" },
                                                  slot: "activator"
                                                },
                                                [
                                                  _c("v-list-tile-action", [
                                                    _c("img", {
                                                      staticClass:
                                                        "align-center cursor-pointer",
                                                      attrs: {
                                                        height: "32",
                                                        width: "32",
                                                        src:
                                                          "/static/Quickbooks-Logo.png"
                                                      }
                                                    })
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v(
                                                          "Quickbooks Customers"
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.unknownCustomers,
                                                function(customer, i) {
                                                  return !_vm.loadingCustomers
                                                    ? [
                                                        _c(
                                                          "v-list-tile",
                                                          {
                                                            key:
                                                              "unknown-customer-" +
                                                              i
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-tile-action"
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        customer.qbDisplayName
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    : _vm._e()
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-tab-item",
                                { attrs: { value: "qb_vendors", lazy: "" } },
                                [
                                  _c(
                                    "v-toolbar",
                                    {
                                      staticClass: "darken-1",
                                      attrs: { flat: "", color: "white" }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "green" } },
                                        [_vm._v("share")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-toolbar-title",
                                        [
                                          _vm._v(
                                            "\n                      Quickbooks Vendors\n\n                      "
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-3",
                                              on: {
                                                click: function($event) {
                                                  return _vm.refreshVendors()
                                                }
                                              }
                                            },
                                            [_vm._v("refresh")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        staticClass: "mx-3",
                                        attrs: {
                                          flat: "",
                                          label: "Search",
                                          "append-icon": "close",
                                          "prepend-inner-icon": "search"
                                        },
                                        on: {
                                          "click:append": function($event) {
                                            _vm.vendorSearch = null
                                          }
                                        },
                                        model: {
                                          value: _vm.vendorSearch,
                                          callback: function($$v) {
                                            _vm.vendorSearch = $$v
                                          },
                                          expression: "vendorSearch"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { "three-line": "" } },
                                    [
                                      _c("v-subheader", [
                                        _vm._v("Vendors with Discounts")
                                      ]),
                                      _vm._v(" "),
                                      _vm.loadingVendors
                                        ? _c(
                                            "v-list-tile",
                                            [
                                              _c("v-progress-circular", {
                                                attrs: {
                                                  indeterminate: "",
                                                  color: "primary"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._l(
                                            _vm.knownVendorsWithDiscounts,
                                            function(vendor, i) {
                                              return [
                                                _c(
                                                  "v-list-group",
                                                  {
                                                    key:
                                                      "vendor-with-discounts-" +
                                                      i
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile",
                                                      {
                                                        key: "vendor-" + i,
                                                        attrs: {
                                                          slot: "activator"
                                                        },
                                                        slot: "activator"
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-tile-action",
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "accent"
                                                                }
                                                              },
                                                              [_vm._v("edit")]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-content",
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    vendor.ltnCompanyName ||
                                                                      vendor.ltnEmployeeName ||
                                                                      vendor.qbDisplayName
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile-sub-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    vendor.qbDisplayName
                                                                  ) +
                                                                    " (" +
                                                                    _vm._s(
                                                                      vendor.qbCompanyId
                                                                    ) +
                                                                    ")"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile-sub-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.vendorSalesTerms(
                                                                      vendor
                                                                    ).name
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.isDirectDispatched(
                                                      vendor
                                                    )
                                                      ? _c(
                                                          "v-list-tile",
                                                          [
                                                            _c(
                                                              "v-list-tile-action",
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      flat: "",
                                                                      fab: "",
                                                                      small: "",
                                                                      color:
                                                                        "accent"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.showUpdateVendorDispatcherDialog(
                                                                          vendor
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "headset_mic"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                vendor.dispatcher
                                                                  ? _c(
                                                                      "v-list-tile-title",
                                                                      [
                                                                        _vm._v(
                                                                          "Dispatcher " +
                                                                            _vm._s(
                                                                              vendor
                                                                                .dispatcher
                                                                                .name
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "v-list-tile-title",
                                                                      [
                                                                        _vm._v(
                                                                          "Add dispatcher contact info"
                                                                        )
                                                                      ]
                                                                    ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-list-tile-sub-title",
                                                                  {
                                                                    staticClass:
                                                                      "font-italic"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._.get(
                                                                          vendor,
                                                                          "dispatcher.email",
                                                                          ""
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-list-tile-sub-title",
                                                                  {
                                                                    staticClass:
                                                                      "font-italic"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._.get(
                                                                          vendor,
                                                                          "dispatcher.phone",
                                                                          ""
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile",
                                                      [
                                                        _c(
                                                          "v-list-tile-action",
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  flat: "",
                                                                  fab: "",
                                                                  small: "",
                                                                  color:
                                                                    "accent"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeVendorMapping(
                                                                      vendor
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "cancel"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-content",
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _vm._v(
                                                                  "Forget this Quickbooks Vendor"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile-sub-title",
                                                              {
                                                                staticClass:
                                                                  "font-italic"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "does not modify your vendor in Quickbooks at all"
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      vendor.vendorDiscounts,
                                                      function(discount, idx) {
                                                        return _c(
                                                          "v-list-tile",
                                                          {
                                                            key: "disc_" + idx
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-tile-action",
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      flat: "",
                                                                      fab: "",
                                                                      small: "",
                                                                      color:
                                                                        "accent"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeVendorDiscountMapping(
                                                                          vendor,
                                                                          discount
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "clear"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        discount.description
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-list-tile-sub-title",
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          _vm.vendorDiscountDescription(
                                                                            discount
                                                                          )
                                                                        ) +
                                                                        "\n                              into account " +
                                                                        _vm._s(
                                                                          _vm.vendorDiscountIncomeAccount(
                                                                            discount
                                                                          )
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            }
                                          ),
                                      _vm._v(" "),
                                      _c("v-subheader", [
                                        _vm._v("Vendors without Discounts")
                                      ]),
                                      _vm._v(" "),
                                      _vm.loadingVendors
                                        ? _c(
                                            "v-list-tile",
                                            [
                                              _c("v-progress-circular", {
                                                attrs: {
                                                  indeterminate: "",
                                                  color: "primary"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._l(
                                            _vm.knownVendorsWithoutDiscounts,
                                            function(vendor, i) {
                                              return [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    key:
                                                      "vendor-no-discounts" + i
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-action",
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              flat: "",
                                                              fab: "",
                                                              small: "",
                                                              color: "accent"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.removeVendorMapping(
                                                                  vendor
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v("cancel")
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vendor.ltnEmployeeName ||
                                                                  vendor.ltnCompanyName
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-sub-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                vendor.qbDisplayName
                                                              ) +
                                                                " (" +
                                                                _vm._s(
                                                                  vendor.qbCompanyId
                                                                ) +
                                                                ")"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.isDirectDispatched(
                                                          vendor
                                                        ) && vendor.dispatcher
                                                          ? _c(
                                                              "v-list-tile-sub-title",
                                                              [
                                                                _vm._v(
                                                                  "\n                            Dispatcher " +
                                                                    _vm._s(
                                                                      vendor
                                                                        .dispatcher
                                                                        .name
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.isDirectDispatched(
                                                      vendor
                                                    )
                                                      ? _c(
                                                          "v-list-tile-avatar",
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  flat: "",
                                                                  fab: "",
                                                                  small: "",
                                                                  color:
                                                                    "accent"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.showUpdateVendorDispatcherDialog(
                                                                      vendor
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "headset_mic"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          ),
                                      _vm._v(" "),
                                      _c("v-subheader", [
                                        _vm._v("Other Vendors")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-group",
                                        [
                                          _c(
                                            "v-list-tile",
                                            {
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _c("v-list-tile-action", [
                                                _c("img", {
                                                  staticClass:
                                                    "align-center cursor-pointer",
                                                  attrs: {
                                                    height: "32",
                                                    width: "32",
                                                    src:
                                                      "/static/Quickbooks-Logo.png"
                                                  }
                                                })
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v("Quickbooks Vendors")
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.unknownVendors, function(
                                            vendor,
                                            i
                                          ) {
                                            return [
                                              _c(
                                                "v-list-tile",
                                                { key: "unknown-vendor-" + i },
                                                [
                                                  _c("v-list-tile-action"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v(
                                                          _vm._s(
                                                            vendor.qbDisplayName
                                                          )
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.nonVendorDrivers.length == 0
                                        ? _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "green" }
                                                    },
                                                    [_vm._v("headset_mic")]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v("Dispatched Drivers")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      "all directly dispatche drivers are known QB vendors"
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.nonVendorDrivers.length > 0
                                        ? _c(
                                            "v-list-group",
                                            [
                                              _c(
                                                "v-list-tile",
                                                {
                                                  attrs: { slot: "activator" },
                                                  slot: "activator"
                                                },
                                                [
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "green"
                                                          }
                                                        },
                                                        [_vm._v("headset_mic")]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v(
                                                          "Dispatched Drivers"
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.nonVendorDrivers,
                                                function(ee, i) {
                                                  return [
                                                    ee.driverProfile
                                                      ? _c(
                                                          "v-list-tile",
                                                          {
                                                            key:
                                                              "non-vendor-driver-" +
                                                              i
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-tile-action"
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        ee.userName
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-bottom-nav",
                    {
                      attrs: { active: _vm.activeTab, value: true },
                      on: {
                        "update:active": function($event) {
                          _vm.activeTab = $event
                        }
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", color: "accent", value: "connect" }
                        },
                        [
                          _vm._v("\n              Connect\n              "),
                          _c("v-icon", { attrs: { color: "green" } }, [
                            _vm._v("offline_bolt")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            color: "accent",
                            value: "defaults",
                            disabled: !_vm.isConnected
                          }
                        },
                        [
                          _vm._v(
                            "\n              Export Defaults\n              "
                          ),
                          _c("V-icon", { attrs: { color: "green" } }, [
                            _vm._v("import_export")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            color: "accent",
                            value: "customers",
                            disabled: !_vm.isConnected
                          }
                        },
                        [
                          _vm._v("\n              Customers\n              "),
                          _c("v-icon", { attrs: { color: "green" } }, [
                            _vm._v("face")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            color: "accent",
                            value: "qb_vendors",
                            disabled: !_vm.isConnected
                          }
                        },
                        [
                          _vm._v("\n              Vendors\n              "),
                          _c("v-icon", { attrs: { color: "green" } }, [
                            _vm._v("share")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e52ef902", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e52ef902","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Sections/QuickbooksSection.vue
// module id = null
// module chunks = 